import Vue from 'vue';
import { DatePicker, Checkbox } from 'element-ui';

Vue.use(DatePicker);
Vue.use(Checkbox);
